module.exports = __webpack_public_path__ + "assets/77bb1e79f0c5ad00d313a978c657ea05.png";